import { useEffect, useRef, useState } from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "../textError";
import { Container, Element, LabelContainer,IconContainer } from "./index.styled";
import { Icon } from "../input/index.styled";


export default function Textarea({
  name,
  placeholder,
  label,
  rightIcon = false,
  width = "404px",
  height = "300px",
  borderColor = "#75a8e8",

}) {
  const inputElement = useRef();
  const [errorMode, setErrorMode] = useState(false);

  useEffect(() => {
    if (errorMode) {
      inputElement.current.style.border = "1px solid #FF3D3D";
    } else {
      inputElement.current.style.border = `1px solid ${borderColor}`;
    }
  }, [errorMode]);

  return (
    <Field name={name}>
      {({ field, meta }) => (
        <div style={{ minHeight: "100px", overflow: "hidden" }}>
          <LabelContainer>
            <label>{label}</label>
          </LabelContainer>
        
          <Container ref={inputElement} width={width} height={height}>
          {rightIcon && (
              <IconContainer rightIcon>
                <Icon src={rightIcon} />
              </IconContainer>
            )}
            <Element as="textarea" placeholder={placeholder} {...field} rightIcon/>
         
          </Container>
          <ErrorMessage component={TextError} name={name} />
          {meta.touched && meta.error
            ? setErrorMode(true)
            : setErrorMode(false)}
        </div>
      )}
    </Field>
  );
}
